module.exports = __webpack_public_path__ + "static/media/burpkitchen5.fb80cfec.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/burpkitchen5.jpg
// module id = 597
// module chunks = 0